import { createSlice } from "@reduxjs/toolkit";
import ProfileAPIs from "api/Profile/index";
import { requests } from 'api/index';
import URLS  from 'api/endPoints';


// Slice

const initiazUserstate = {
    COUNTRYMASTER: "",
    STATEMASTER: "",
    CITYMASTER: "",
    DEGREEMASTER: "",
    UNIVERSITYMASTER: "",
    COLLEGEMASTER: "",
    SPECIALIZATION:"",
    DESIGNATION:"",
    CURRENCY:"",
    DEPARTMENT:"",
    EMPTYPE:"",
    LANGUAGE:"",
    INDUSTRY:"",
    EDUCATIONGROUP:"",
    SKILL:"",
    RATING:""
}

const slice = createSlice({
  name: "Masters",
  initialState: {
    info: initiazUserstate,
  },
  reducers: {
    getCOUNTRYMASTER: (state, action) => {
      state.info.COUNTRYMASTER = action.payload;
    },
    getSTATEMASTER: (state, action) => {
      state.info.STATEMASTER = action.payload;
    },
    getCITYMASTER: (state, action) => {
      state.info.CITYMASTER = action.payload;
    },
    getDEGREEMASTER: (state, action) => {
      // action.payload.map((val, index) => {
      state.info.DEGREEMASTER = action.payload;
      // })
    },
    getUNIVERSITYMASTER: (state, action) => {
      state.info.UNIVERSITYMASTER = action.payload;
    },
    getCOLLEGEMASTER: (state, action) => {
        state.info.COLLEGEMASTER = action.payload;
      },
      getSPECIALIZATIONMASTER: (state, action) => {
        state.info.SPECIALIZATION = action.payload;
      },
      getDESIGNATION: (state, action) => {
        state.info.DESIGNATION = action.payload;
      },
      getCURRENCY: (state, action) => {
        state.info.CURRENCY = action.payload;
      },
      getDEPARTMENTMASTER: (state, action) => {
        state.info.DEPARTMENT = action.payload;
      },
      getEMPTYPEMASTER: (state, action) => {
        state.info.EMPTYPE = action.payload;
      },
      getLANGUAGEMASTER: (state, action) => {
        state.info.LANGUAGE = action.payload;
      },
      getINDUSTRYMASTER: (state, action) => {
        state.info.INDUSTRY = action.payload;
      },
      getEDUCATIONGROUPMASTER: (state, action) => {
        state.info.EDUCATIONGROUP = action.payload;
      },
      getSKILLMASTER: (state, action) => {
        state.info.SKILL = action.payload;
      },
      getRATINGMASTER: (state, action) => {
        state.info.RATING = action.payload;
      },
  },
});

export default slice.reducer;

// Actions

const {getCOUNTRYMASTER,
    getSTATEMASTER,
    getCITYMASTER,
    getDEGREEMASTER,
    getUNIVERSITYMASTER,
    getCOLLEGEMASTER,
    getSPECIALIZATIONMASTER,
    getDESIGNATION,
    getCURRENCY,
    getDEPARTMENTMASTER,
    getEMPTYPEMASTER,
    getLANGUAGEMASTER,
    getEDUCATIONGROUPMASTER,
    getINDUSTRYMASTER,
    getSKILLMASTER,
    getRATINGMASTER} = slice.actions
export const getCOUNTRYMASTERAction = (user) => async dispatch => {
    try {
    let response= await ProfileAPIs.countryMaster(user);
    // console.log(response, "from billboard");
    if(response.ResponseCode==100){
    await dispatch(getCOUNTRYMASTER(response));
    }
    return await returnCode(response);
  } catch (e) {
    return console.error(e.message);
  }
};

export const getSTATEMASTERAction = (user) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.stateMaster(user);
    // console.log(response.Data, "from getfeaturedapi")
    if(response.ResponseCode==100){
    await dispatch(getSTATEMASTER(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const getCITYMASTERAction = (user) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.cityMaster(user);
    if(response.ResponseCode==100){
    await dispatch(getCITYMASTER(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};

export const getDEGREEMASTERAction = (user) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.degreeMasterFiltered(user);
    if(response.ResponseCode==100){
    await dispatch(getDEGREEMASTER(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};

export const getUNIVERSITYMASTERAction = (id) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.universityMaster(id);
    if(response.ResponseCode==100){
    await dispatch(getUNIVERSITYMASTER(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const getCOLLEGEMASTERAction = (id) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.collegeMaster(id);
    if(response.ResponseCode==100){
    await dispatch(getCOLLEGEMASTER(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const getSPECIALIZATIONMASTERAction = (id) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.specializationMaster(id);
    if(response.ResponseCode==100){
    await dispatch(getSPECIALIZATIONMASTER(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const getDESIGNATIONAction = (id) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.designation(id);
    if(response.ResponseCode==100){
    await dispatch(getDESIGNATION(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const getCURRENCYAction = (id) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.currency(id);
    if(response.ResponseCode==100){
    await dispatch(getCURRENCY(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const getDEPARTMENTMASTERAction = (id) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.department(id);
    if(response.ResponseCode==100){
    await dispatch(getDEPARTMENTMASTER(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const getEMPTYPEMASTERAction = (id) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.emptype(id);
    if(response.ResponseCode==100){
    await dispatch(getEMPTYPEMASTER(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const getINDUSTRYMASTERAction = (id) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.industry(id);
    if(response.ResponseCode==100){
    await dispatch(getINDUSTRYMASTER(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};

export const getLANGUAGEMASTERAction = (id) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.language(id);
    if(response.ResponseCode==100){
    await dispatch(getLANGUAGEMASTER(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const getEDUCATIONGROUPMASTERAction = (id) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.educationgroup(id);
    if(response.ResponseCode==100){
    await dispatch(getEDUCATIONGROUPMASTER(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
// //postMethod

// export const setBasicAction = (user) => async dispatch => {
//   try {
//   let response= await ProfileAPIs.postBasic(user);
//    console.log(response, "from [post]");
//   //await dispatch(getBasic(response));
//   return await returnCode(response);
// } catch (e) {
//   return console.error(e.message);
// }
// };
export const getSKILLMASTERAction = (id) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.skill(id);
    if(response.ResponseCode==100){
    await dispatch(getSKILLMASTER(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const getRATINGMASTERAction = (id) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.Rating(id);
    if(response.ResponseCode==100){
    await dispatch(getRATINGMASTER(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
function returnCode(response) {
  if (response.ResponseCode == 100 || 200) {
    return response;
  } else if (response.ResponseCode == 103) {
    return 103;
  } else {
    return 101;
  }
}
